import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { IMessageGroupOutputModel, IMessageGroupMemberInputModel, IMessageGroupMGInputModel } from 'src/app/ViewModel/CommunicationModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { Observable, of, Subject } from 'rxjs';
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { ITransmittalMemberModel } from 'src/app/ViewModel/TransmittalTemplateModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { debounceTime, exhaustMap, filter, scan, startWith, switchMap, tap } from 'rxjs/operators';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { MemberRoleLinkService } from 'src/app/Service/member-role-link/member-role-link.service';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipList } from '@angular/material/chips';


@Component({
  selector: 'app-message-group',
  templateUrl: './message-group.component.html',
  styleUrls: ['./message-group.component.css']
})
export class MessageGroupComponent implements OnInit {

  panelOpenState = true;
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public roleId!: number;
  public setDisableGrpMsg: boolean = true;
  public showBtn: boolean = true;
  public updatedDescription!: string;
  toList: any[] = [];
  ccList: any[] = [];
  project_allMembers: any[] = [];
  bccList: any[] = [];
  msgGrpId: number | undefined;
  public membersList: any[] = [];
  masterMembers: ITransmittalMemberModel[] = [];
  @ViewChild('toInput')
  toInput!: ElementRef<HTMLInputElement>;
  @ViewChild('toauto')
  matToAutoComplete!: MatAutocomplete;
  @ViewChild('toChipList')
  toChipList!: MatChipList;
  @ViewChild('ccInput')
  ccInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ccauto')
  matCcAutoComplete!: MatAutocomplete;
  @ViewChild('ccChipList')
  ccChipList!: MatChipList;
  @ViewChild('bccInput')
  bccInput!: ElementRef<HTMLInputElement>;
  @ViewChild('bccauto')
  matbccAutoComplete!: MatAutocomplete;
  @ViewChild('bccChipList')
  bccChipList!: MatChipList;
  toMembers: ITransmittalMemberModel[] = [];
  tofilter$!: Observable<any>;
  toFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  ccMembers: ITransmittalMemberModel[] = [];
  ccfilter$!: Observable<any>;
  ccFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  bccMembers: ITransmittalMemberModel[] = [];
  bccfilter$!: Observable<any>;
  bccFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  private _nextPage$ = new Subject();
  separatorKeysCodes: number[] = [ENTER, SPACE, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;
  mgList: any[] = [];
  removedCcMember: any[] = [];
  removedBccMember: any[] = [];
  removedToMember: any[] = [];
  public businessGroupId!: number;
  groupList: IMessageGroupOutputModel[] = [];
  bindGroupList: IMessageGroupOutputModel[] = [];
  public receivers: IMessageGroupMemberInputModel[] = [];
  public messageGroupForm!: FormGroup;
  public businessGroupList: ReadonlyArray<BusinessGroupModel> = [];

  constructor(
    public dialogRef: MatDialogRef<MessageGroupComponent>,
    public communicationService: CommunicationService,
    public commonService: CommonService,
    public memberService: ExternalMemberService,
    private memberRoleLinkService: MemberRoleLinkService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private mapRoleFeatureService: MapRoleFeatureService,
    private transmittalService: TransmittalService,
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.createCommunicationForm();
    this.callMemberRoleandFeature();
    this.get_Allmember();
    this.getBusinessGroupList(this.projectId);
    this.getMessageGroupList();
  }

  createCommunicationForm() {
    this.messageGroupForm = this.formBuilder.group({
      toMembersCtrl: new FormControl(),
      ccMembersCtrl: new FormControl(),
      bccMembersCtrl: new FormControl(),
      toMembers: [[], [Validators.required, this.validateMemberSelection.bind(this)]],
      ccMembers: [[], [Validators.required, this.validateMemberSelection.bind(this)]],
      bccMembers: [[], [Validators.required, this.validateMemberSelection.bind(this)]],
      txtNoOfDays: new FormControl(),
      formToMember: new FormControl('', Validators.required),
      formMGList: new FormControl('', Validators.required),
      business_GroupId: new FormControl(),
      formMGListList: new FormControl('', Validators.required)
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  changeBusinessGroup(event: { value: string | number | any; }) {
    if (event.value != '-2') {
      this.businessGroupId = event.value;
      this.getMembers();
    } else {
      this.showBtn = true;
      this.masterMembers = [];
    }
  }


  resetData() {
    this.toFormMembers?.setValue([]);
    this.toFormMembers?.updateValueAndValidity();
    this.resetToMemberFilter();
    this.ccFormMembers?.setValue([]);
    this.ccFormMembers?.updateValueAndValidity();
    this.resetCcMemberFilter();
    this.bccFormMembers?.setValue([]);
    this.bccFormMembers?.updateValueAndValidity();
    this.resetbccMemberFilter();
  }

  filterGroupList(event: any) {
    let messageGroup: String = this.messageGroupForm.get('formMGList')?.value;
    let enteredMSG = this.mgList.filter(data => data.groupDescription.trim() == messageGroup.trim())[0];
    if (!!enteredMSG) {
      this.showBtn = false;
      this.resetRemovedMember();
      this.messageGroupForm.get('formMGListList')?.setValue(enteredMSG.groupDescription);
      this.bindMembers(enteredMSG.groupId);
      this.msgGrpId = enteredMSG.groupId;
    } else {
      this.showBtn = true;
      this.resetData();
      this.msgGrpId = undefined;
      this.bindMembers(undefined);
      this.messageGroupForm.get('formMGListList')?.setValue(undefined);
    }
  }

  get_Allmember() {
    this.transmittalService.getProjectMembers().subscribe((res: ProjectMemberModel[]) => {
      this.project_allMembers = res.map(x => {
        let transmittalMember: ITransmittalMemberModel = {
          memberId: x.memberId,
          memberName: x.memberName,
          memberShortName: x.memberShortName,
          eMailId: x.eMailId,
          mobileNo: x.mobileNo,
          staffPSNo: x.staffPSNo
        };
        return transmittalMember;
      });

    })
    this.tofilter$ = this.createSerachFilter('toMembersCtrl');
    this.ccfilter$ = this.createSerachFilter('ccMembersCtrl');
    this.bccfilter$ = this.createSerachFilter('bccMembersCtrl');
    this.filterMembers();
  }
  async getMembers() {
    this.membersList = await this.memberRoleLinkService.getMembersList(this.commonService.getProjectId(), this.businessGroupId).toPromise();
    this.masterMembers = this.membersList.map(x => {
      let transmittalMember: ITransmittalMemberModel = {
        memberId: x.memberId,
        memberName: x.memberName,
        memberShortName: x.memberShortName,
        eMailId: x.eMailId,
        mobileNo: x.mobileNo,
        staffPSNo: x.staffPSNo
      };
      return transmittalMember;
    });
    this.tofilter$ = this.createSerachFilter('toMembersCtrl');
    this.ccfilter$ = this.createSerachFilter('ccMembersCtrl');
    this.bccfilter$ = this.createSerachFilter('bccMembersCtrl');
    this.filterMembers();
  }



  setMessageReceivers() {
    this.toMembers.forEach(x => {
      this.receivers.push({
        MemberId: x.memberId,
        UserId: this.memberId,
        MessageGroupId: !!this.msgGrpId ? this.msgGrpId : 0,
        GroupId: this.groupId,
        ProjectId: this.projectId,
        RoleId: this.roleId,
        ReceiverType: 2,
        IsActive: true
      });
    });

    this.ccMembers.forEach(x => {
      this.receivers.push({
        MemberId: x.memberId,
        UserId: this.memberId,
        MessageGroupId: !!this.msgGrpId ? this.msgGrpId : 0,
        GroupId: this.groupId,
        ProjectId: this.projectId,
        RoleId: this.roleId,
        ReceiverType: 3,
        IsActive: true
      });
    });

    this.bccMembers.forEach(x => {
      this.receivers.push({
        MemberId: x.memberId,
        UserId: this.memberId,
        MessageGroupId: !!this.msgGrpId ? this.msgGrpId : 0,
        GroupId: this.groupId,
        ProjectId: this.projectId,
        RoleId: this.roleId,
        ReceiverType: 5,
        IsActive: true
      });
    });
    return this.receivers;
  }

  validateMemberSelection(abstractControl: AbstractControl) {
    if (abstractControl.touched || abstractControl.dirty) {
      let selectedValue: any[] = abstractControl.value;
      if (selectedValue && !selectedValue.every(member => this.masterMembers.includes(member))) {
        return { IsError: true };
      } else {
        return null;
      }
    }
    else return null;
  }

  getBusinessGroupList(projectId: number) {
    this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe((data: BusinessGroupModel[]) => {
      this.businessGroupList = data.filter(eachData => eachData.is_Active);
    });
  }
  private createSerachFilter(formControlName: string): Observable<any> {
    // Note: listen for search text changes  
    let x: any = this.messageGroupForm;
    if (x && x.get(formControlName))
      return x.get(formControlName).valueChanges.pipe(
        startWith(''),
        debounceTime(200),
        filter(q => typeof q === "string"));
    return new Observable<any>();
  }

  private filterMembers(): void {
    this.toFilteredMembers = this.getFilteredMembers(this.tofilter$);
    this.ccFilteredMembers = this.getFilteredMembers(this.ccfilter$);
    this.bccFilteredMembers = this.getFilteredMembers(this.bccfilter$);
  }

  private getFilteredMembers(filter$: Observable<any>): Observable<ITransmittalMemberModel[]> {
    return filter$.pipe(
      switchMap((filter: any) => {
        //Note: Reset the page with every new seach text
        let currentPage = 1;
        return this._nextPage$.pipe(
          startWith(currentPage),
          exhaustMap(_ => this.getMembersFake(filter, currentPage)),
          tap(() => currentPage++),
          scan((allMembers, newMembers: any) => allMembers.concat(newMembers), []),
        );
      }));
  }

  // Fake backend api
  private getMembersFake(startsWith: string, page: number): Observable<ITransmittalMemberModel[]> {
    const take = 10;
    const skip = page > 0 ? (page - 1) * take : 0;
    const filtered = this.masterMembers
      .filter((option: any) => option.memberName.toLowerCase().includes(startsWith.toLowerCase()));
    return of(filtered.slice(skip, skip + take));
  }

  optionClicked(event: Event, member: ITransmittalMemberModel, type: string) {
    event.stopPropagation();
    switch (type) {
      case 'to':
        this.toggleToSelection(member);
        break;
      case 'cc':
        this.toggleCcSelection(member);
        break;
      case 'bcc':
        this.togglebccSelection(member);
        break;
    }
  }


  onChangeSearch(val: any) {
    this.updatedDescription = val;
  }

  selectEvent(item: any) {
    if (!!item.tE_Description)
      this.updatedDescription = item.tE_Description;
    if (!!item.tI_Description)
      this.updatedDescription = item.tI_Description;
  }
  isMemberSelected(member: ITransmittalMemberModel, type: string): boolean {
    let result: boolean = false;
    switch (type) {
      case 'to':
        result = this.toMembers != null ? this.toMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
      case 'cc':
        result = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
      case 'bcc':
        result = this.bccMembers != null ? this.bccMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
    }
    return result;
  }

  toggleToSelection(member: ITransmittalMemberModel) {
    const index: number = this.toMembers != null ? this.toMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.toMembers.splice(index, 1);
      this.toFormMembers?.value.splice(index, 1);
      this.toFormMembers?.updateValueAndValidity();
    }
    else {
      this.toMembers.push(member);
      this.toFormMembers?.value.push(member);
      this.toFormMembers?.updateValueAndValidity();
      this.resetToMemberFilter();
    }
  }

  resetToMemberFilter() {
    this.messageGroupForm.get('toMembersCtrl')?.setValue('');
    this.toInput.nativeElement.value = '';
    this.toInput.nativeElement.blur();
  }

  removeTo(member: ITransmittalMemberModel): void {
    const index = this.toMembers.indexOf(member);
    if (index >= 0) {
      this.removedToMember.push(member);
      this.toMembers.splice(index, 1);
      if (this.toFormMembers?.status != "VALID") {
        // Remove element from control value array
        this.toFormMembers?.value.splice(index, 1);
        // where index = index of removed element
        this.toFormMembers?.updateValueAndValidity();
      }
      this.resetToMemberFilter();
    }
  }

  toggleCcSelection(member: ITransmittalMemberModel) {
    const index: number = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.ccMembers.splice(index, 1);
      this.ccFormMembers?.value.splice(index, 1);
      this.ccFormMembers?.updateValueAndValidity();
    }
    else {
      this.ccMembers.push(member);
      this.ccFormMembers?.value.push(member);
      this.ccFormMembers?.updateValueAndValidity();
      this.resetCcMemberFilter();
    }
  }

  resetCcMemberFilter() {
    this.messageGroupForm.get('ccMembersCtrl')?.setValue('');
    this.ccInput.nativeElement.value = '';
    this.ccInput.nativeElement.blur();
  }


  removeCc(member: ITransmittalMemberModel): void {
    const index = this.ccMembers.indexOf(member);
    if (index >= 0) {
      this.removedCcMember.push(member);
      this.ccMembers.splice(index, 1);
      if (this.ccFormMembers?.status != "VALID") {
        // Remove element from control value array
        this.ccFormMembers?.value.splice(index, 1);
        // where index = index of removed element
        this.ccFormMembers?.updateValueAndValidity();
      }
      this.resetCcMemberFilter();
    }
  }

  togglebccSelection(member: ITransmittalMemberModel) {
    const index: number = this.bccMembers != null ? this.bccMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.bccMembers.splice(index, 1);
      this.bccFormMembers?.value.splice(index, 1);
      this.bccFormMembers?.updateValueAndValidity();
    }
    else {
      this.bccMembers.push(member);
      this.bccFormMembers?.value.push(member);
      this.bccFormMembers?.updateValueAndValidity();
      this.resetbccMemberFilter();
    }
  }

  resetbccMemberFilter() {
    this.messageGroupForm.get('bccMembersCtrl')?.setValue('');
    this.bccInput.nativeElement.value = '';
    this.bccInput.nativeElement.blur();
  }

  onMGValueChange(event: { value: string; additionalValues: { additionalValues: { groupId: number | undefined; groupDescription: any; }; }; }, formControlName: string) {
    if (event.value != '-2') {
      this.removedBccMember = [];
      this.removedCcMember = [];
      this.removedToMember = [];
      this.showBtn = false;
      this.msgGrpId = event.additionalValues.additionalValues.groupId;
      this.messageGroupForm.get('formMGList')?.setValue(event.additionalValues.additionalValues.groupDescription);
      this.messageGroupForm.get('formMGListList')?.setValue(event.additionalValues.additionalValues.groupDescription);
      this.bindMembers(event.value);
    } else {
      this.toMembers = [];
      this.ccMembers = [];
      this.bccList = [];
      this.showBtn = true;
      this.msgGrpId = undefined;
      this.resetRemovedMember();
      this.messageGroupForm.get('formMGList')?.setValue('');
      this.bindMembers(event.value);
    }
  }

  bindMembers(value: string | number | undefined) {
    this.toMembers = [];
    this.ccMembers = [];
    this.bccList = [];
    this.bindGroupList = this.groupList.filter(x => x.groupId == value);
    this.toList = this.bindGroupList.filter(x => x.receiverType == 2).map(x => {
      return {
        value: x.memberId,
        title: x.memberName,
        isGroup: x.receiverType != 0,
        isActive: true,
        groupId: x.groupId,
        groupName: x.groupDescription
      }
    });
    this.toMembers = this.getMGListMembers(this.toList);
    if (this.toMembers != null) {
      this.toMembers = this.toMembers.filter(data => data != null);
      this.toFormMembers?.setValue([...this.toMembers]);
    }
    this.toFormMembers?.updateValueAndValidity();
    this.resetToMemberFilter();

    this.ccList = this.bindGroupList.filter(x => x.receiverType == 3).map(x => {
      return {
        value: x.memberId,
        title: x.memberName,
        isGroup: x.receiverType != 0,
        isActive: true,
        groupId: x.groupId,
        groupName: x.groupDescription
      }
    });

    this.ccMembers = this.getMGListMembers(this.ccList);
    if (this.ccMembers != null) {
      this.ccMembers = this.ccMembers.filter(data => data != null);
      this.ccFormMembers?.setValue([...this.ccMembers]);
    }
    this.ccFormMembers?.updateValueAndValidity();
    this.resetCcMemberFilter();

    this.bccList = this.bindGroupList.filter(x => x.receiverType == 5).map(x => {
      return {
        value: x.memberId,
        title: x.memberName,
        isGroup: x.receiverType != 0,
        isActive: true,
        groupId: x.groupId,
        groupName: x.groupDescription
      }
    });

    this.bccMembers = this.getMGListMembers(this.bccList);
    if (this.bccMembers != null) {
      this.bccMembers = this.bccMembers.filter(data => data != null);
      this.bccFormMembers?.setValue([...this.bccMembers]);
    }
    this.bccFormMembers?.updateValueAndValidity();
    this.resetbccMemberFilter();
  }

  private getMGListMembers(members: any): ITransmittalMemberModel[] {
    return members.map((x: { value: any; title: any; receiverGroup: any; }) => {
      let findmember = this.project_allMembers.filter(y => y.memberId == x.value)[0];
      let member!: ITransmittalMemberModel
      if (!!findmember) {
        member = {
          memberId: x.value,
          memberName: x.title,
          memberShortName: findmember.memberShortName,
          eMailId: findmember.eMailId,
          staffPSNo: findmember.staffPSNo,
          mobileNo: findmember.mobileNo,
          groupBy: x.receiverGroup
        };
        return member;
      }
      else
        return member
    });
  }

  removebcc(member: ITransmittalMemberModel): void {
    const index = this.bccMembers.indexOf(member);
    if (index >= 0) {
      this.removedBccMember.push(member);
      this.bccMembers.splice(index, 1);
      // Remove element from control value array
      this.bccFormMembers?.value.splice(index, 1);
      // where index = index of removed element
      this.bccFormMembers?.updateValueAndValidity();
      this.resetbccMemberFilter();
    }
  }

  // use getter method to access toMembers control value easily
  get toFormMembers() {
    return this.messageGroupForm.get('toMembers');
  }
  get ccFormMembers() {
    return this.messageGroupForm.get('ccMembers');
  }
  get bccFormMembers() {
    return this.messageGroupForm.get('bccMembers');
  }

  async callMemberRoleandFeature() {
    this.commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe((result: any[]) => {
      this.roleId = result.length > 0 ? result[0].role_Id : 1;
    });
  }

  async getMessageGroupList() {
    this.groupList = await this.communicationService.GetMessageGroup({ MemberId: this.memberId, ProjectId: this.projectId }).toPromise();
    let mgList1 = this.groupList.map((element => {
      return { "groupId": element.groupId, "groupDescription": element.groupDescription };
    }));
    this.mgList = mgList1.reduce((accumalator: any, current: any) => {
      if (!accumalator.some((item: any) => item.groupId === current.groupId && item.groupDescription === current.groupDescription)) {
        accumalator.push(current);
      }
      return accumalator;
    }, []);
  }

  /**
   * Get elementDetailsForm Controls value
   * @param controlName ControlName
   */
  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }

  resetRemovedMember() {
    this.removedToMember = [];
    this.removedCcMember = [];
    this.removedBccMember = [];
  }

  saveMessageGroup() {
    let RemovedToMember: IMessageGroupMemberInputModel[] = [];
    let RemovedCcMember: IMessageGroupMemberInputModel[] = [];
    let RemovedBccMember: IMessageGroupMemberInputModel[] = [];
    if (this.removedToMember.length > 0) {
      this.removedToMember.forEach(x => {
        RemovedToMember.push({
          MemberId: x.memberId,
          UserId: this.memberId,
          MessageGroupId: !!this.msgGrpId ? this.msgGrpId : 0,
          GroupId: this.groupId,
          ProjectId: this.projectId,
          RoleId: this.roleId,
          ReceiverType: 2,
          IsActive: false
        });
      });
    }
    if (this.removedCcMember.length > 0) {
      this.removedCcMember.forEach(x => {
        RemovedCcMember.push({
          MemberId: x.memberId,
          UserId: this.memberId,
          MessageGroupId: !!this.msgGrpId ? this.msgGrpId : 0,
          GroupId: this.groupId,
          ProjectId: this.projectId,
          RoleId: this.roleId,
          ReceiverType: 3,
          IsActive: false
        });
      });
    }
    if (this.removedBccMember.length > 0) {
      this.removedBccMember.forEach(x => {
        RemovedBccMember.push({
          MemberId: x.memberId,
          UserId: this.memberId,
          MessageGroupId: !!this.msgGrpId ? this.msgGrpId : 0,
          GroupId: this.groupId,
          ProjectId: this.projectId,
          RoleId: this.roleId,
          ReceiverType: 5,
          IsActive: false
        });
      });
    }
    if (this.toMembers.length > 0 && this.getFormValue('formMGList', this.messageGroupForm)) {
      this.setMessageReceivers();
      let receivers = this.receivers.concat(...RemovedToMember, ...RemovedCcMember, ...RemovedBccMember);
      let inputModel: IMessageGroupMGInputModel = {
        MemberId: this.memberId,
        OwnerId: this.memberId,
        GroupId: this.groupId,
        MessageGroupId: this.msgGrpId,
        ProjectId: this.commonService.getProjectId(),
        GroupDescription: this.getFormValue('formMGList', this.messageGroupForm),
        IsActive: true,
        MessageGroupMembers: receivers,
      };
      this.callService(inputModel);
    }
    else {
      this.notificationService.showToast("Mandatory fields are Required", "Warning");
    }
  }

  callService(inputModel: IMessageGroupMGInputModel) {
    this.communicationService.InsertUpdateMessageGroup(inputModel).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200 || res.successCode == 205) {
        this.closeDialog();
        this.notificationService.showToast(res.successMessage, "Success");
        // this.getDistributionList();
      }
      else {
        this.notificationService.showToast(res.successMessage, "Error");
      }
    });
    this.resetRemovedMember();
  }

}
